export const FIELD_VALIDATION_RULES = {
  jobShareStructurePointValue: { min: 1, max: 10_000 },
  jobShareStructureNumDrawTickets: { min: 1, max: 20 },
  candidateExpressInterestPointValue: { min: 10, max: 99_999 },
  CompletedOrientationPointValue: { min: 200, max: 99_999 },
  CompletedFirstShiftPointValue: { min: 1_000, max: 99_999 },
  hundredHourWorkedPointValue: { min: 1_000, max: 99_999 },
  threeHundredHourWorkedPointValue: { min: 1_000, max: 99_999 },
};
